import React from 'react';
import Header from '@shared/header/header.container';
import ContactForm from '../contact-form/contact-form.container';
import GoBack from '../shared/go-back/go-back.container';

const ProspectsPageContent: React.FunctionComponent = () => {
  return (
    <>
      <Header type="product" isFormPage />
      <GoBack />
      <ContactForm type="client_prospects" />
    </>
  );
};

export default ProspectsPageContent;
